module.exports = __webpack_public_path__ + "img/20191105164154360截图20191105155003314.0bfd81ee.jpg";